import React from 'react';
import { Menu, Dropdown } from 'antd';
import './SelectCity.scss';

const menu = (
    <Menu className="select-city__menu">
        <Menu.Item key="0">
            <p>Выберите город:</p>
        </Menu.Item>
        <Menu.Item key="1">
            <a className="select-city__item" href="https://n.asklepiy-dv.ru/">Находка</a>
        </Menu.Item>
        <Menu.Item key="2">
            <a className="select-city__item" href="https://u.asklepiy-dv.ru/">Уссурийск</a>
        </Menu.Item>
    </Menu>
);

const SelectCity = () => {
    return (
        <Dropdown overlay={menu} trigger={['click']}>
            <div className="select-city">
                <i className="bi bi-geo-alt-fill select-city__map me-2"></i>
                <p>Владивосток <span>(сменить город)</span></p>
                <i className="bi bi-chevron-down select-city__arrow ms-1 pt-1"></i>
            </div>
        </Dropdown>
    );
};

export default SelectCity;